import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
    templateUrl: './route-link-cell.component.html',
    standalone: false
})
export class RouteLinkCellComponent implements ICellRendererAngularComp {
  public link: string;
  public urlTarget: string;
  public value: any;

  private data: any;
  private queryParamValue: any;
  private cellRenderParams: any;

  agInit(params: ICellRendererParams<any, any>): void {
    this.data = params.data;
    this.cellRenderParams = params.colDef.cellRendererParams;
    this.queryParamValue = this.data[(this.cellRenderParams as any).queryParamProperty];

    this.value = this.data[(this.cellRenderParams as any).valueProperty];
    this.link = this.cellRenderParams?.link + this.queryParamValue;
    this.urlTarget = (params as any).newTab ? '_blank' : '_self';
  }

  refresh(): boolean {
    return false;
  }
}
